import common from 'common';
function doWebSocket(open, message, close, error) {
  let uri = common.getSession('websocket_wss_url');
  if (!uri) {
    return;
  }
  uri = 'wss://' + uri;
  let c = new WebSocket(uri);
  c.onopen = open;
  c.onmessage = message;
  c.onclose = close;
  c.onerror = function (err) {
    error(err);
  };
}
export default {
  doWebSocket: doWebSocket,
};



// WEBPACK FOOTER //
// ./src/js/socket.js